import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { ColumnSelectComponent } from '../column-select/column-select.component';

@Component({
  selector: 'app-bus-report',
  templateUrl: './bus-report.component.html',
  styleUrls: ['./bus-report.component.css']
})
export class BusReportComponent implements OnInit {

  public menu_item_id = '96';
  private dp = [];

  displayedColumns = ['sr', 'invoice_no', 'trip_name', 'head_name', 'mobile', 'cont_type', 'bus_no',
    'male_seat_count', 'female_seat_count', 'depart_date', 'return_date', 'from_city_name', 'to_city_name', 
    'seat_price'];

  model = {
    'trip_name': '', 'trip_number': '', 'trip_status': 'active', 'bus_id': '0', 'title': 'تقرير الباص',
    'trip_id': '0', 'depart_date': new Date(), 'return_date': new Date(), 'from_city': '', 'to_city': '', 
    'type_id': 'all', 'search_type': 'date'
  };

  bus_list = [];
  city_list = [];

  type_list = [{ 'type_id': 'all', 'type_name': 'الكل', 'type_name_en': 'All' },
  { 'type_id': 'program', 'type_name': 'عقود البرامج السياحية', 'type_name_en': 'Tourism Programs Contracts' },
  { 'type_id': 'special_prog', 'type_name': 'عقود البرامج الخاصة', 'type_name_en': 'Special Programs Contracts' }];

  today = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();

  search_prog = {
    'placeholder': 'اسم البرنامج/ رقم البرنامج', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`trip`', 'selected_no': 'trip_id',
      'field_list': ['trip_name', 'trip_number'],
      'condition': " AND `trip`.`arrival_date` >= '" + this.today + "'"
    }]
  };

  dialog_data = [{ 'id': 'sr', 'title_ar': 'الرقم', 'title_en': 'Number', 'checked': '1' },
    { 'id': 'invoice_no', 'title_ar': 'رقم العقد', 'title_en': 'Contract Number', 'checked': '1' },
    { 'id': 'trip_name', 'title_ar': 'اسم البرنامج', 'title_en': 'Program Name', 'checked': '1' },
    { 'id': 'head_name', 'title_ar': 'رئيس المجموعة', 'title_en': 'Group Head', 'checked': '1' },
    { 'id': 'customer_name_en', 'title_ar': 'الاسم الإنجليزي', 'title_en': 'English Name', 'checked': '0' },
    { 'id': 'mobile', 'title_ar': 'رقم الجوال', 'title_en': 'Mobile', 'checked': '1' },
    { 'id': 'cont_type', 'title_ar': 'نوع العقد', 'title_en': 'Contract Type', 'checked': '1' },
    { 'id': 'bus_no', 'title_ar': 'رقم الباص', 'title_en': 'Bus Number', 'checked': '1' },
    { 'id': 'male_seat_count', 'title_ar': 'عدد مقاعد الرجال', 'title_en': 'Male Seats', 'checked': '1' },
    { 'id': 'female_seat_count', 'title_ar': 'عدد مقاعد النساء', 'title_en': 'Female Seats', 'checked': '1' },
    { 'id': 'total_seat_count', 'title_ar': 'مجموع المقاعد', 'title_en': 'Total Seat', 'checked': '0' },
    { 'id': 'depart_date', 'title_ar': 'تاريخ المغادرة', 'title_en': 'Departure Date', 'checked': '1' },
    { 'id': 'return_date', 'title_ar': 'تاريخ العودة', 'title_en': 'Return Date', 'checked': '1' },
    { 'id': 'from_city_name', 'title_ar': 'من مدينة', 'title_en': 'From City', 'checked': '1' },
    { 'id': 'to_city_name', 'title_ar': 'إلى مدينة', 'title_en': 'To City', 'checked': '1' },
    { 'id': 'seat_price', 'title_ar': 'سعر المقعد', 'title_en': 'Seat Price', 'checked': '1' },
    { 'id': 'total', 'title_ar': 'المجموع', 'title_en': 'Total', 'checked': '0' }];
  // dialog_data = [];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;
  colDialogRef: MatDialogRef<ColumnSelectComponent>;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private route: ActivatedRoute, private router: Router,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  Bus_Report; Prog_Name; Prog_No; Smoker; Non_Smoker;
  Program_Placeholder; Dep_Ret_Msg; Prog_Msg; Select;

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Bus_Report').subscribe((res: string) => {
      this.Bus_Report = res;
    });
    this.model['title'] = this.Bus_Report;

    translate.get('Prog_Name').subscribe((res: string) => {
      this.Prog_Name = res;
    });

    translate.get('Prog_No').subscribe((res: string) => {
      this.Prog_No = res;
    });

    translate.get('Smoker').subscribe((res: string) => {
      this.Smoker = res;
    });

    translate.get('Non_Smoker').subscribe((res: string) => {
      this.Non_Smoker = res;
    });

    translate.get('Program_Placeholder').subscribe((res: string) => {
      this.Program_Placeholder = res;
    });
    this.search_prog.placeholder = this.Program_Placeholder;

    translate.get('Dep_Ret_Msg').subscribe((res: string) => {
      this.Dep_Ret_Msg = res;
    }); ;

    translate.get('Prog_Msg').subscribe((res: string) => {
      this.Prog_Msg = res;
    });  

    translate.get('Select').subscribe((res: string) => {
      this.Select = res;
    }); 
  }

  ngOnInit() {
    let query = "SELECT * FROM `bus` WHERE `status` = '1'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.bus_list = data.data['list'];
        this.bus_list.unshift({'bus_id': '0', 'bus_no': this.Select})
      });

    query = this.queryList.all_city;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.city_list = data.data['list'];
      });
  }

  onChangeProg = function (search_result: object) {
    this.model['trip_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  changeStatus() {
    if (this.model['trip_status'] == 'active')
      this.search_prog['table_list']['0']['condition'] = " AND `trip`.`arrival_date` >= '" + this.today + "'";
    else
      this.search_prog['table_list']['0']['condition'] = " AND `trip`.`arrival_date` < '" + this.today + "'";
  }

  search() {

    if ((this.model['type_id'] != 'program' &&this.model['depart_date'] == undefined && 
      this.model['return_date'] == undefined) || (this.model['type_id'] == 'program' && 
      this.model['search_type'] == 'date' && this.model['depart_date'] == undefined && 
      this.model['return_date'] == undefined)) {
        alert(this.Dep_Ret_Msg);
        return;
    }

    if (this.model['type_id'] == 'program' && this.model['search_type'] == 'trip' && 
      this.model['trip_id'] == '0') {
      alert(this.Prog_Msg);
      return;
    }

    let obj = { cmd: 'getBusRep' };

    obj['type_id'] = this.model['type_id'];

    if (this.model['bus_id'] != '0')
      obj['bus_id'] = this.model['bus_id'];

    if (this.model['type_id'] != 'program' || (this.model['type_id'] == 'program' && this.model['search_type'] == 'date')) {
      
      if (this.model['depart_date'] != undefined)
        obj['depart_date'] = this.model['depart_date'].getFullYear() + "-" + (this.model['depart_date'].getMonth() + 1) + "-" +
          this.model['depart_date'].getDate();

      if (this.model['return_date'] != undefined)
        obj['return_date'] = this.model['return_date'].getFullYear() + "-" + (this.model['return_date'].getMonth() + 1) + "-" +
          this.model['return_date'].getDate();

      if (this.model['from_city'] != '')
        obj['from_city'] = this.model['from_city'];
  
      if (this.model['to_city'] != '')
        obj['to_city'] = this.model['to_city'];
    }
    else if (this.model['type_id'] == 'program' && this.model['search_type'] == 'trip') 
      obj['trip_id'] = this.model['trip_id'];

    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data);

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  column_select() {
    this.colDialogRef = this.dialog.open(ColumnSelectComponent, {
      hasBackdrop: false,
      data: this.dialog_data
    });
    this.colDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != undefined) {
          console.log(result);
          this.dialog_data = result;
          this.displayedColumns = [];
          this.dialog_data.forEach(element => {
            if (element.checked == '1')
              this.displayedColumns.push(element.id);
          });
        }
      });
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Bus_Report + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('prog_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }


}
